import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

const IGNORED_ERRORS = [
  // Next.js route cancellation (user navigates away before render completes)
  // Example: { message: 'ResizeObserver loop limit exceeded' }
  // Example: { message: /Loading chunk \d+ failed/i }
  { message: 'Cancel rendering route' }
];

function shouldIgnoreError(event) {
  const error = event.errors?.[0];
  const errorMessage =
    error?.errorMessage || event.originalError?.message || '';

  // Check cancelled flag (Next.js navigation)
  if (event.originalError?.cancelled) {
    return true;
  }

  // Check against ignored errors list
  return IGNORED_ERRORS.some(({ message }) => {
    if (message instanceof RegExp) {
      return message.test(errorMessage);
    }
    return errorMessage === message;
  });
}

Bugsnag.start({
  apiKey: process.env.BUGSNAG_API_KEY,
  appVersion: process.env.APP_VERSION,
  logger: null,
  consoleBreadcrumbsEnabled: false,
  onError(event) {
    if (shouldIgnoreError(event)) {
      return false;
    }

    const reportApp = event.app;
    const requestUrl = event.request.url;
    if (requestUrl.match(/(?:.+\.)?bina\.az/g)) {
      reportApp.releaseStage = 'production';
      reportApp.notifyReleaseStages = 'production';
    } else {
      reportApp.releaseStage = process.env.VERCEL_GITHUB_BRANCH;
      reportApp.notifyReleaseStages = process.env.VERCEL_GITHUB_BRANCH;
    }
  },
  plugins: [new BugsnagPluginReact()]
});

export default Bugsnag;
